import { render, staticRenderFns } from "./SocialSeriesDialog.vue?vue&type=template&id=53e980d9&scoped=true&"
import script from "./SocialSeriesDialog.vue?vue&type=script&lang=js&"
export * from "./SocialSeriesDialog.vue?vue&type=script&lang=js&"
import style0 from "./SocialSeriesDialog.vue?vue&type=style&index=0&id=53e980d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e980d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e980d9')) {
      api.createRecord('53e980d9', component.options)
    } else {
      api.reload('53e980d9', component.options)
    }
    module.hot.accept("./SocialSeriesDialog.vue?vue&type=template&id=53e980d9&scoped=true&", function () {
      api.rerender('53e980d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialSeriesDialog.vue"
export default component.exports